import { useEffect, useRef, useState } from 'react';

import clsx from 'clsx';
import YouTube from 'react-youtube';
import VideoLogo from '../../assets/images/svg/Video.svg';
import { ReactComponent as PulsingTriangle } from '../../assets/images/svg/Pulsing triangle.svg';

import './Video.css'

function getDurationText(duration) {
    const minutes = (Math.floor(duration / 60)).toString().padStart(2, '0');
    const seconds = (duration - minutes * 60).toString().padStart(2, '0');
    return <span>{minutes.toString()}&apos;{seconds}&quot;</span>
}

function Video({
    className,
    videoId,
    background,
    watchText
}) {

    const [isStarted, setIsStarted] = useState(false);
    const [duration, setDuration] = useState(0);
    const [title, setTitle] = useState(null);
    const [player, setPlayer] = useState(null);
    const [height, setHeight] = useState(0);
    const videoPlayer = useRef(null);

    useEffect(() => {
        // on initial render
        setTimeout(() => {
            updateHeight();
        }, 0);

        function updateHeight() {
            const { width } = videoPlayer.current.getBoundingClientRect();
            setHeight(Math.round(width * 0.4692));
        }

        window.addEventListener('resize', updateHeight);

        return () => {
            window.removeEventListener('resize', updateHeight);
        }
    }, [])

    function onReady(event) {
        const { target } = event;
        setPlayer(target);
        setDuration(target.getDuration());
        // Youtube API doc is instable for getVideoData(). Sometime it's there, sometimes it's not.
        // If there is a problem with the title, this is most likely the culprit.
        setTitle(target.getVideoData().title);
    }

    function onStart() {
        setIsStarted(true);
        player.playVideo();
    }

    return (
        <div className={clsx('video-player', className)} style={{ height: `${height ?? 0}px` }} ref={videoPlayer}>
            {!isStarted && (
                <div className='video-cover-wrapper'>
                    <div
                        className='video-cover-background'
                    >
                        <div className='offuscator'></div>
                        <img className="video-cover-image" src={background} alt="Video cover" />
                    </div>
                    <div className='video-cover-content' onClick={() => onStart()}>
                        <div className='video-cover-duration'>
                            <div className='duration-block'>
                                <img src={VideoLogo} alt="Video logo" />
                                {getDurationText(duration)}
                            </div>
                        </div>
                        <div className='video-cover-title'>
                            <span className='video-title'>{title}</span>
                        </div>
                        <div className='video-cover-text'>
                            <span>
                                <div className='fancy-triangle'>
                                    <PulsingTriangle className='triangle' />
                                    <PulsingTriangle className='triangle' />
                                    <PulsingTriangle className='triangle' />
                                </div>
                                {watchText}
                            </span>
                        </div>
                    </div>
                </div>

            )}
            <YouTube videoId={videoId} onReady={onReady} />
        </div>
    )
}

export default Video;